export class CarteiraModel {

    cod_cliente?: string
    valor_contrato?: number
    valor_contrato_texto?:string
    qtd?: number
    qtd_escada?: number
    qtd_plataforma?: number
    qtd_total?: number
    data_proposta?: Date
    canc_cli?: Date
    nome?: string
    contrato?: string
    end_rps?: string
    bairro?: string
    cidade?: string
    estado?: string
    cep?: string
    tem?: string
    coligada?: string
    setor?: string
    descricaoTitulo?: string
    qtd_clientes?: number
    media_elevador?: number
    media_elevador_texto?: string
    filtro_data_inicial: Date
    filtro_data_final: Date

}